"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const creators_1 = require("@App/helpers/work-entities/creators");
const contexts_1 = require("@App/contexts");
const AddWriterFormFlow_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter/AddWriterFormFlow"));
const AddWriter = ({ closePopupFunc }) => {
    const { workStore, writerSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [writerData, setWriterData] = (0, react_1.useState)({
        firstName: '',
        lastName: '',
        ipiNumber: '',
        roleCode: null,
        writerShare: null,
    });
    const closePopupOrClearForm = (closePopup = true) => {
        if (closePopup) {
            closePopupFunc();
        }
        else {
            setWriterData({
                firstName: '',
                lastName: '',
                ipiNumber: '',
                roleCode: null,
                writerShare: null,
            });
        }
    };
    const addWriterToDraft = (closePopup = true) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedWork = (0, creators_1.createUpdatingWorkDraft)(workDraftFromLocal, 'writers', writerData);
        workStore.setWorkDraftToLocal(updatedWork);
        closePopupOrClearForm(closePopup);
    };
    const setFoundWriterToDraft = (writer_1, ...args_1) => __awaiter(void 0, [writer_1, ...args_1], void 0, function* (writer, closePopup = true) {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const writers = workDraftFromLocal.writers;
        const lastWriterId = writers.length ? Number(writers[writers.length - 1].localId) : 0;
        const newWriter = {
            localId: lastWriterId + 1,
            ipId: writer.ipId,
            firstName: writer.firstName ? writer.firstName : null,
            lastName: writer.lastName, // REQUIRED FIELD
            ipiNumber: writer.ipiNumber ? writer.ipiNumber : null,
            roleCode: writer.roleCode,
            writerShare: 0,
        };
        const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { writers: [...writers, newWriter] });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
        closePopupOrClearForm(closePopup);
    });
    (0, react_1.useEffect)(() => () => {
        writerSearchStore.clearStore();
    }, []);
    if (!writerData) {
        return null;
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(AddWriterFormFlow_1.default, { setFoundWriterToDraft: setFoundWriterToDraft, addWriterToDraft: addWriterToDraft, writerData: writerData, setWriterData: setWriterData })));
};
exports.default = (0, mobx_react_1.observer)(AddWriter);
